export type SiteConfig = typeof siteConfig
export const siteConfig = {
    name: "Finding Frankie",
    slogan: "slogan",
    icon: "/favicon.ico",
    appleIcon: "/apple-touch-icon.png",
    gameIframe: "https://rumble.com/embed/v4xsz1b/?pub=4",
    domain: "findingfrankie.org",
    gaId: "G-6KY4WS1J33",
    navbarItems: [
        {
            title: "title",
             href: "/",
        }
    ],
}
